import { useEffect, useState } from "react"
import { useIdleTimer } from "react-idle-timer"
import jwt_decode from 'jwt-decode';
import { useAuth } from "../authentication/useAuth";

// The API's full token life (TOKEN_LIFE in authenticateUser.js); a shorter token means the 12-hour limit is near
const TOKEN_LIFE = 16 * 60;

/**
 * @param onIdle - opens the password box, with the reason: 'idle' or 'limit' (the 12 hours are up)
 * @param idleTime - seconds without activity before the session locks and asks for the password; 2 minutes later it signs out
 */
const useIdleTimeout = ({ onIdle, idleTime = 900 }) => {
    const idleTimeout = 1000 * idleTime;
    const [isIdle, setIdle] = useState(false)
    const { logout, keepAlive, token } = useAuth();
    const handleIdle = () => {
        setIdle(true)
        logout()
    }
    // After 15 idle minutes the prompt locks the session (the token is cleared) and asks for the password
    const idleTimer = useIdleTimer({
        timeout: idleTimeout,
        promptTimeout: 1000 * 120,
        onPrompt: () => onIdle('idle'),
        onIdle: handleIdle,
        // Activity renews the token at most once a minute
        onAction: keepAlive,
        throttle: 60 * 1000
    })
    // Near the 12-hour limit the API stops renewing. Show the password box a minute before the token runs out,
    // over the page, so the user carries on without losing work. Timed from the token's own iat/exp, not the device clock
    useEffect(() => {
        const { iat, exp } = token ? jwt_decode(token) : {};
        // A few seconds of slack: the API stamps iat just after it works out exp
        if (!iat || exp - iat > TOKEN_LIFE - 10) return;
        const timer = setTimeout(() => onIdle('limit'), Math.max(0, (exp - iat - 60) * 1000));
        return () => clearTimeout(timer);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    return {
        isIdle,
        setIdle,
        idleTimer
    }
}
export default useIdleTimeout;
